import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { trimProjectReportTemplate } from "../../entities/trimProjectReportTemplate";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getProjectReportTemplate(planzone)
        .then((reportTemplates) => ({
          planzone,
          reportTemplates: reportTemplates.map((t) => ({
            ...t,
            ...trimProjectReportTemplate(t),
          })),
        }))
        .catch(() => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
